export enum PermissionTypeEnum {
  ADMIN = 1,
  UPLOAD_HUB = 10,
  UPLOAD_HUB_ADMIN = 11,
}
